import MuiPaper from "@mui/material/Paper";
import { Table } from "../../../components/Table";
import { useStyles } from "../styles";

type CategoriesProps = {
  loading: boolean;
  categories: any[];
};

export function Categories({ loading, categories }: CategoriesProps) {
  const styles = useStyles();
  return (
    <MuiPaper
      className={styles.paperCreatedDay}
      variant="outlined"
      elevation={0}
    >
      <Table
        isLoading={loading}
        toolbar={false}
        data={categories}
        columns={[
          {
            title: "Categoria",
            field: "faixas",
          },
          {
            title: "Produtos",
            field: "faixas",
          },
          {
            title: "Vendas",
            field: "faixas",
          },
          {
            title: "Investimento",
            field: "faixas",
          },
          {
            title: "Faturamento",
            field: "faixas",
          },
          {
            title: "ROI",
            field: "faixas",
          },
          {
            title: "Ticket médio",
            field: "faixas",
          },
          {
            title: "Margem",
            field: "faixas",
          },
          {
            title: "Margem percentual",
            field: "faixas",
          },
        ]}
        style={{ backgroundColor: "transparent" }}
        headerStyle={{ backgroundColor: "transparent" }}
        options={{
          actionsColumnIndex: -1,
          pageSize: 3,
          selectionProps: () => ({ color: "primary" }),
        }}
      />
    </MuiPaper>
  );
}
